import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * PauseIcon - A pause icon (two vertical bars)
 */
export const PauseIcon = ({ size = 16, color = "#374151", className = "", ...props }) => {
    return (_jsxs(Icon, { size: size, viewBox: "0 0 16 16", className: className, ...props, children: [_jsx("path", { d: "M5.5 2C5.22386 2 5 2.22386 5 2.5V13.5C5 13.7761 5.22386 14 5.5 14H6.5C6.77614 14 7 13.7761 7 13.5V2.5C7 2.22386 6.77614 2 6.5 2H5.5Z", fill: color }), _jsx("path", { d: "M9.5 2C9.22386 2 9 2.22386 9 2.5V13.5C9 13.7761 9.22386 14 9.5 14H10.5C10.7761 14 11 13.7761 11 13.5V2.5C11 2.22386 10.7761 2 10.5 2H9.5Z", fill: color })] }));
};
